export default "__VITE_ASSET__0e983335__"